import { autoinject, bindable } from "aurelia-framework";
import "./comp-navigation.scss";

@autoinject
export class CompNavigation {

    @bindable()
    public navItems: NavItems[];

    @bindable()
    public showOnlyExternal: boolean;

    internallNavItems: NavItems[];
    externalNavItems: NavItems[];
    selectedNavItem: NavItems;
    isHorizontal: boolean = false;
    isGrabbing: boolean = false;

    constructor(private element: Element){}
    
    attached() {
        this.selectedNavItem = this.navItems[0];

        this.internallNavItems = this.navItems.filter((navItem: NavItems) => { return !navItem.isExtrnalLink });
        this.externalNavItems = this.navItems.filter((navItem: NavItems) => { return navItem.isExtrnalLink });
    }
    
    async onNavClick(navItem: NavItems) {
        if(navItem.isExtrnalLink) {
            if (navItem.downloadFileName && navItem.route) {
                const response = await fetch(navItem.route);
                const fileBlob = await response.blob();
                const fileUrl = window.URL.createObjectURL(fileBlob);
                const link = document.createElement("a");
                link.href = fileUrl;
                link.download = navItem.downloadFileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(fileUrl);
                return;
            }

            open(navItem.route, '_blank');
            
        } else {
            this.selectedNavItem = navItem;
        
            const navClickEvent: CustomEvent = new CustomEvent("nav-item-click", { bubbles: true, 
                detail: { navItem }
            });
            
            //Custom event
            this.element.dispatchEvent(navClickEvent);   
        }
    }

    onMousedown(event) {
        const mousedownEvent: CustomEvent = new CustomEvent("drag-nav", { bubbles: true, detail: { event } });
        
        //Custom event
        this.element.dispatchEvent(mousedownEvent);
    }

    rotateNav(){
        this.isHorizontal = !this.isHorizontal;
    }
}

export interface NavItems {
    value: string;
    index: number;
    route?: string;
    downloadFileName?: string;
    isExtrnalLink?: boolean;
}